"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsigned_user_documents_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../main");
const document_1 = require("../document");
const unsigned_user_documents_1 = require("../../../../api/calls/document/unsigned_user_documents");
exports.unsigned_user_documents_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/unsigned_user_documents_thunk", (data, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, document_1.setInboxLoading)(true));
    const response = yield (0, unsigned_user_documents_1.unsigned_user_documents)(data);
    dispatch((0, document_1.setInboxLoading)(false));
    if (response.success) {
        dispatch((0, document_1.setUnsignedUserDocuments)(response.content.documents));
        dispatch((0, document_1.setUnsignedUserDocumentsCount)(response.content.count));
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
}));
